import { render } from "./BannerPropsCmp.vue?vue&type=template&id=54cef826"
import script from "./BannerPropsCmp.vue?vue&type=script&lang=js"
export * from "./BannerPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__